<template>
  <v-form v-model="valid" ref="form" class="form">
    <v-container class="pa-4">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            :value="lastName"
            v-on:input="$emit('updateLastName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ФАМИЛИЯ"
            placeholder="ИВАНОВ"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="firstName"
            v-on:input="$emit('updateFirstName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ИМЯ"
            placeholder="ИВАН"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="middleName"
            v-on:input="$emit('updateMiddleName', ($event || '').trim())"
            :rules="[rules.required, rules.counter]"
            :counter="40"
            label="ОТЧЕСТВО"
            placeholder="ИВАНОВИЧ"
            type="input"
            filled
            dense
            clearable
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            :value="email"
            v-on:input="$emit('updateEmail', ($event || '').trim())"
            :rules="[rules.required, rules.email]"
            :counter="40"
            prepend-inner-icon="mdi-email-outline"
            label="E-MAIL"
            placeholder="ivanovivan@mail.ru"
            type="email"
            dense
            filled
            clearable
            required
          ></v-text-field>

          <v-text-field
            :value="phone"
            v-on:input="$emit('updatePhone', ($event || '').trim())"
            :rules="[rules.required, rules.phone]"
            :counter="40"
            label="КОНТАКТНЫЙ ТЕЛЕФОН"
            placeholder="+7916-455-33-33"
            prepend-inner-icon="mdi-phone-outline"
            :succes-messages="['Ok']"
            type="phone"
            dense
            filled
            clearable
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-select
        :value="mychoise"
        :items="sourceItems"
        item-text="title"
        v-on:input="$emit('updateMychoise', ($event || '').trim())"
        :rules="rules.stdchoice"
        dense
        filled
        required
        :label="requestType"
      ></v-select>

      <v-text-field
        v-show="isCustomAbonement"
        :value="customAbonement"
        v-on:input="$emit('updateCustomAbonement', ($event || '').trim())"
        :rules="rules.customchoice"
        :counter="80"
        :placeholder="'ВВЕДИТЕ ' + requestType"
        filled
        dense
        clearable
        required
      ></v-text-field>

      <v-checkbox
        class="mb-0 pb-0"
        :value="ihavecertificat"
        v-on:change="$emit('updateIhavecertificat', $event)"
        :label="'У меня есть действующий абонемент студии (скидка 10%)'"
        hide-details="true"
      ></v-checkbox>

      <v-row class="my-0 py-0">
        <v-col cols="1"></v-col>
        <v-col cols="6">
          <v-text-field
            dense
            v-show="ihavecertificat"
            :value="mycertificat"
            v-on:input="$emit('updateMycertificat', ($event || '').trim())"
            label="НОМЕР"
            placeholder="12345678"
            filled
            clearable
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "FormType1",
  props: {
    lastName: String,
    firstName: String,
    middleName: String,
    email: String,
    phone: String,
    mychoise: String,
    customAbonement: String,
    mycertificat: String,
    ihavecertificat: Boolean,
    isAbonement: Boolean,
    info: Object,
  },
  emits: [
    "updateLastName",
    "updateFirstName",
    "updateMiddleName",
    "updateEmail",
    "updatePhone",
    "updateDescription",
    "updateBirthday",
    "updateCustomAbonement",
    "updateMychoise",
    "updateValid",
    "updateIhavecertificat",
    "updateMycertificat",
  ],

  data() {
    return {
      valid: false,
      model: null,
      index: 0,
      mydatasareverifyed: false,
      rules: {
        required: (v) => (v || "").trim().length > 0 || "Необходимо заполнить.",
        counter: (v) => (v || "").trim().length <= 40 || "Не более 40 символов",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Неверное имя e-mail";
        },
        phone: (value) => {
          const pattern =
            /^\+{0,1}(7|8){0,1}((-| |\(|\)){0,1}\d{3}){2}(-| |\)){0,1}(\d{2}(-| ){0,1}){2}$/;
          return pattern.test(value) || "Неверный номер телефона";
        },
        customchoice: [
          (v) =>
            !this.isCustomAbonement ||
            (v || "").trim().length > 0 ||
            "Необходимо заполнить поле",
        ],
        stdchoice: [
          (v) => !!v || "Необходимо заполнить поле",
          (v) => (v || "").trim().length > 0 || "Необходимо заполнить поле",
        ],
      },
    };
  },

  computed: {
    sourceItems() {
      if (this.isAbonement) return this.info.abonements;
      return this.info.certificates;
    },

    requestType() {
      if (this.isAbonement) return "АБОНЕМЕНТ";
      return "СЕРТИФИКАТ";
    },

    isCustomAbonement() {
      return this.mychoise !== null && this.mychoise === "ДРУГОЕ";
    },
  },
  watch: {
    valid() {
      this.validateField();
      this.$emit("updateValid", this.valid);
    },
    isCustomAbonement() {
      this.validateField();
    },
  },

  methods: {
    validateField() {
      this.$refs.form.validate();
    },
  },
};
</script>
